module.exports = __webpack_public_path__ + "img/dotted-v-line-3.b2a8f6ef.svg";